import Vue from 'vue';

const SELECTORS = {
    LOGIN: '.js-login-component',
    REGISTER: '.js-register-component',
    RESET_PASSWORD: '.js-reset-password-component',
};

class LoginForm {
    constructor(el, isModal = false) {
        import(
            /* webpackChunkName: "LoginComponent" */
            '~/components/forms/login-component.vue'
        ).then((m) => {
            return new Vue({
                render: h => h(m.default, { props: { isModal } }),
                el,
            });
        });
    }
}

class RegisterForm {
    constructor(el, isModal = false) {
        import(
            /* webpackChunkName: "RegisterComponent" */
            '~/components/forms/register-component.vue'
        ).then((m) => {
            return new Vue({
                render: h => h(m.default, { props: { isModal } }),
                el,
            });
        });
    }
}

class ResetPasswordForm {
    constructor(el) {
        import(
            /* webpackChunkName: "ResetPasswordComponent" */
            '~/components/forms/reset-password-component.vue'
        ).then((m) => {
            return new Vue({
                render: h => h(m.default),
                el,
            });
        });
    }
}

const $loginForm = document.querySelector(SELECTORS.LOGIN);
if ($loginForm) {
    new LoginForm($loginForm);
}

const $registerForm = document.querySelector(SELECTORS.REGISTER);
if ($registerForm) {
    new RegisterForm($registerForm);
}

const $resetPasswordForm = document.querySelector(SELECTORS.RESET_PASSWORD);
if ($resetPasswordForm) {
    new ResetPasswordForm($resetPasswordForm);
}

export { LoginForm, RegisterForm, ResetPasswordForm }
